package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.css.cursor
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Transition
import org.jetbrains.compose.web.css.Transitions
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.lennycodes.hldi.constants.HLDITheme

val SubscribeButtonStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.InlineBlock)
            .backgroundColor(HLDITheme.Colors.accent)
            .color(HLDITheme.Colors.primary)
            .border(0.px, LineStyle.None)
            .borderRadius(6.px)
            .fontWeight(600)
            .cursor(Cursor.Pointer)
            .transition(
               transition = com.varabyte.kobweb.compose.css.Transition.all(
                    duration = 0.3.s,
                    timingFunction = TransitionTimingFunction.Ease
                )
            )
    }

    hover {
        Modifier
            .backgroundColor(HLDITheme.Colors.white)
            .transform { translateY((-2).px) }
    }
}